import {fnGetCodeVal, eventMessageObj, getChildrenFindVal} from '~/utils/admin-common'
import {pcDownloadFile} from '~/utils/files'
export const state = () => ({
  apiUrl: {
    log_stat: '/api/lr/prism/log/{display_id}/stat',
    log_result: '/api/lr/prism/log/{display_id}/result',
    log_message_info: '/api/lr/prism/log/message/info',
    log_save: '/api/lr/prism/log/{display_id}/save'
  },
  eventCodes: [],
  eventConfig: [],
  eventLevelTypes: [],
  search: {
    id: '',
    page_num: 1,
    isFirst: true
  },
  searchData: {
    log_type: '',
    stime: '',
    etime: '',
    total_rows: 10000,
    page_rows: 1000,
    order_by: 'desc',
    filters: []
  },
  searchState: {
    status: 'INIT', // 초기 단계: INIT, 추이 검색 중: SEARCHING_TREND_LOG, 로그 검색 중: SEARCHING_LOG, 검색 중지 요청 중: REQUEST_STOP, 로그 검색이 중지 됨: STOPPED, 로그 검색 완료: DONE
    progress: 0,
    searched_cnt: 0
  },
  // 필터 key 변경
  filterKey: {
    event_level_type: 'event_level_type',
    device_grp_id: 'device_grp_id',
    device_id: 'device_id',
    event_code: 'event_code',
    event_type_name: 'event_type',
    admin_id: 'admin_id',
    admin_login_ip: 'admin_login_ip',
    menu_code: 'menu_id',
    audit_log_result_type: 'audit_log_result_type'
  },
  // data
  dataList: [],
  eventErrorMessage: '',
  menuData: [],
  resultType: [
    {value: '1', label: '성공'},
    {value: '0', label: '실패'}
  ]
})
export const mutations = {
  errorSearch (state) {
    state.dataList = []
  },
  mutSetMenuData (state, payload) {
    state.menuData = payload
  },
  mutGetSearchResult (state, payload) {
    state.dataList = payload.filter(item => {
      const eventObj = eventMessageObj(state.eventCodes, item.event_code, item.event_log_set)
      item.event_code_name = eventObj['name']
      item.message = eventObj['message']
      item.event_level_type_name = fnGetCodeVal('event_level_type', item.event_level_type)

      const typeName = state.eventConfig.filter(_config => {
        return _config.type === item.event_type
      })
      item.event_type_name = typeName.length > 0 ? typeName[0].name : ''
      return item
    })
  },
  mutGetAuditLogSearchResult (state, payload) {
    state.dataList = []
    state.dataList = payload.filter(item => {
      item.menu_id_name = getChildrenFindVal(state.menuData, {id: 'code', val: item.menu_id.toString()}, 'name')
      let label = ''
      const val = state.resultType.filter(_item => {
        return _item.value === item.audit_log_result_type.toString()
      })
      if (val.length > 0) {
        label = val[0].label
      }
      item.audit_log_result_type = label
      return item
    })
  },
  mutGetSearchState (state, payload) {
    state.searchState.searched_cnt = payload[0].cnt
    state.search.page_num = 1
  },
  setEventLevelList (state, payload) {
    if (payload.length > 0) {
      const typeColor = {}
      _.forEach(payload, (item) => {
        typeColor[`${item.event_level_type}`] = item.event_level_color
      })
      state.eventLevelTypes = typeColor
    }
  },
  mutEventMessageInfo (state, payload) {
    state.eventCodes = payload
  },
  mutEventMessageInfoDetail (state, payload) {
    state.eventConfig = payload
  },
  mutEventErrorMessage (state, payload) {
    state.eventErrorMessage = payload
  }
}
export const actions = {

  async getSearchState ({commit, state}) {
    try {
      const apiUrl = state.apiUrl.log_stat.replace('{display_id}', state.searchData.log_type)
      const req = {}
      req[state.searchData.log_type + '_start_dt'] = state.searchData.stime
      req[state.searchData.log_type + '_end_dt'] = state.searchData.etime

      state.searchData.filters.forEach(item => {
        const key = state.filterKey[item.key]
        const codesD = (item.code[item.key] !== undefined) ? item.code[item.key] : item.code
        if (typeof key !== 'undefined') {
          const listKey = `${key}_list`
          if (key === 'audit_log_result_type') {
            req[key] = parseInt(codesD[0])
          } else {
            req[listKey] = codesD.map(x => {
              return isNaN(x) ? x : parseInt(x)
            })
          }

          if (item.key !== 'admin_login_ip') {
            req[`${key}_not_yn`] = (item.is_not) ? 1 : 0
          }
        }
      })
      const res = await this.$axios.$post(apiUrl, req, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('mutGetSearchState', res.result)
      }
      return res
    } catch (error) {
      commit('mutEventErrorMessage', error.message)
      return {code: 'nok', result: {msg: error.message}}
    }
  },
  async getSearchResult ({commit, state}) {
    const apiUrl = state.apiUrl.log_result.replace('{display_id}', state.searchData.log_type)
    const req = {
      order_by: state.searchData.order_by,
      page_cnt: state.searchData.page_rows,
      page_pos: (state.search.page_num - 1)
    }
    req[state.searchData.log_type + '_start_dt'] = state.searchData.stime
    req[state.searchData.log_type + '_end_dt'] = state.searchData.etime

    state.searchData.filters.forEach(item => {
      const key = state.filterKey[item.key]
      const codesD = (item.code[item.key] !== undefined) ? item.code[item.key] : item.code
      if (typeof key !== 'undefined') {
        const listKey = `${key}_list`
        if (key === 'audit_log_result_type') {
          req[key] = parseInt(codesD[0])
        } else {
          req[listKey] = codesD.map(x => {
            return isNaN(x) ? x : parseInt(x)
          })
        }

        if (item.key !== 'admin_login_ip') {
          req[`${key}_not_yn`] = (item.is_not) ? 1 : 0
        }
      }
    })
    try {
      const res = await this.$axios.$post(apiUrl, req, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        state.dataList = res.result
      } else {
        state.dataList = []
      }

      return res
    } catch (error) {
      state.dataList = []
      commit('mutEventErrorMessage', error.message)
      return {code: 'nok', result: {msg: error.message}}
    }
  },
  // 이벤트 레벨별 색상
  async getEventLevelType ({commit}) {
    try {
      const {code, result} = await this.$axios.$get('/api/sm/event-level')
      if (code === 'ok') {
        commit('setEventLevelList', result)
        return result
      } else {
        commit('mutEventErrorMessage', result.msg)
        return []
      }
    } catch (e) {
      commit('mutEventErrorMessage', e.message)
      return []
    }
  },
  async getTamsFilterDatas ({commit}) {
    try {
      const {code, result} = await this.$axios.$get('/api/sm/devices', { params: {device_id: 2} })
      if (code === 'ok') {
        const tamsDataArr = []
        _.forEach(result, (d) => {
          d.value = `${d.device_id}`
          tamsDataArr.push(d)
        })
        return tamsDataArr
      } else {
        return []
      }
    } catch (e) {
      commit('mutEventErrorMessage', e.message)
      return []
    }
  },
  async getAdminFilterDatas ({commit}) {
    try {
      const {code, result} = await this.$axios.$get('/api/lr/prism/log/admin-filter')
      if (code === 'ok') {
        const adminDataArr = []
        _.forEach(result, (d) => {
          d.value = `${d.admin_id}`
          adminDataArr.push(d)
        })
        return adminDataArr
      } else {
        return []
      }
    } catch (e) {
      commit('mutEventErrorMessage', e.message)
      return []
    }
  },
  async acsEventMessageInfo ({commit, state}) {
    try {
      const apiUrl = `${state.apiUrl.log_message_info}/basic`
      const res = await this.$axios.$get(apiUrl, {}, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('mutEventMessageInfo', res.result.event)
        return res.result.event
      } else {
        commit('mutEventErrorMessage', res.msg)
      }
    } catch (e) {
      commit('mutEventErrorMessage', e.message)
      return []
    }
  },
  async acsEventMessageInfoDetail ({commit, state}) {
    try {
      const apiUrl = `${state.apiUrl.log_message_info}/detail`
      const res = await this.$axios.$get(apiUrl, {}, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('mutEventMessageInfoDetail', res.result.event)
        return res.result.event
      } else {
        commit('mutEventErrorMessage', res.msg)
      }
    } catch (e) {
      commit('mutEventErrorMessage', e.message)
      return []
    }
  },
  async acsSaveFile ({commit, state}) {
    const result = {}
    try {
      const req = {
        order_by: state.searchData.order_by,
        page_cnt: state.searchData.page_rows,
        page_pos: (state.search.page_num - 1)
      }
      req[state.searchData.log_type + '_start_dt'] = state.searchData.stime
      req[state.searchData.log_type + '_end_dt'] = state.searchData.etime

      state.searchData.filters.forEach(item => {
        const key = state.filterKey[item.key]
        const codesD = (item.code[item.key] !== undefined) ? item.code[item.key] : item.code
        if (typeof key !== 'undefined') {
          const listKey = `${key}_list`
          if (key === 'audit_log_result_type') {
            req[key] = parseInt(codesD[0])
          } else {
            req[listKey] = codesD.map(x => {
              return isNaN(x) ? x : parseInt(x)
            })
          }

          if (item.key !== 'admin_login_ip') {
            req[`${key}_not_yn`] = (item.is_not) ? 1 : 0
          }
        }
      })
      const apiUrl = state.apiUrl.log_save.replace('{display_id}', state.searchData.log_type)
      const result = await this.$axios.$file(apiUrl, req, {responseType: 'blob', loading: false, successAlert: false, returnErr: true})
      if (result.code !== undefined) {
        const blob = new Blob([result.data])
        const reader = new FileReader()
        const _this = this
        reader.onload = () => {
          const msgObj = JSON.parse(reader.result)
          const msgTxt = msgObj.result.msg
          _this.$router.app.$alertPopUp.show(msgTxt)
        }
        reader.readAsText(blob)
      } else {
        pcDownloadFile(result.data, result.fileName)
        return ''
      }

      result.code = 'ok'
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return []
    }
  }
}
export const getters = {}
export const strict = false
